import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";
import { Home, Search, Trophy } from "lucide-react";

export default function NotFound() {
  const { t, lang } = useI18n();
  const ar = lang === "ar";

  return (
    <div className="min-h-[80vh] mx-auto max-w-3xl px-5 py-20 flex flex-col items-center justify-center text-center" data-testid="not-found-page">
      <div className="relative">
        <div className="text-[10rem] md:text-[14rem] leading-none font-black gold-text tracking-tighter select-none">404</div>
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="h-40 w-40 md:h-56 md:w-56 rounded-full bg-[#D4AF37]/10 blur-3xl" />
        </div>
      </div>

      <h1 className="text-3xl md:text-4xl font-black tracking-tight mt-4">
        {ar ? "الصفحة غير موجودة" : "Page Not Found"}
      </h1>
      <p className="text-white/60 mt-3 max-w-lg leading-relaxed">
        {ar
          ? "الرابط الذي تبحث عنه غير متوفر أو ربما تم نقله. تحقق من العنوان أو عُد للصفحة الرئيسية."
          : "The link you’re looking for doesn’t exist or may have been moved. Check the URL or head back home."}
      </p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link to="/" className="btn-gold rounded-full px-5 py-2.5 inline-flex items-center gap-2 text-sm font-bold" data-testid="not-found-home-btn">
          <Home className="h-4 w-4" /> {ar ? "الرئيسية" : "Home"}
        </Link>
        <Link to="/leaderboard" className="btn-gold-outline rounded-full px-5 py-2.5 inline-flex items-center gap-2 text-sm" data-testid="not-found-leaderboard-btn">
          <Trophy className="h-4 w-4" /> {t("leaderboard")}
        </Link>
        <Link to="/try" className="rounded-full px-5 py-2.5 inline-flex items-center gap-2 text-sm border border-emerald-500/40 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20 transition" data-testid="not-found-try-btn">
          <Search className="h-4 w-4" /> {t("try_free")}
        </Link>
      </div>
    </div>
  );
}
